export const COLLEGE_LEVELS = [
    { name: 'FBS Power Conf', content: 'FBS Power Conf', value: 'FBS Power Conf' },
    { name: 'FBS Non-Power Conf', content: 'FBS Non-Power Conf', value: 'FBS Non-Power Conf' },
    { name: 'FCS', content: 'FCS', value: 'FCS' },
    { name: 'Div II', content: 'Div II', value: 'Div II' },
    { name: 'Div III', content: 'Div III', value: 'Div III' },
    { name: 'NAIA', content: 'NAIA', value: 'NAIA' },
    { name: 'JUCO', content: 'JUCO', value: 'JUCO' },
  ];


  export const NFL_OPTIONS = [
    { value: 'drafted', content: 'Drafted'},
    { value: 'udfa', content: 'Undrafted (UDFA)'},
  ];